export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_SESSSION = "SET_SESSSION";
export const SET_TOKEN = "SET_TOKEN";


export const ADD_PURCHASED_STOCK = 'ADD_PURCHASED_STOCK';
export const SET_PURCHASED_STOCKS = 'SET_PURCHASED_STOCKS';
export const CLEAR_PURCHASED_STOCKS = 'CLEAR_PURCHASED_STOCKS';
export const REMOVE_PURCHASED_STOCK = 'REMOVE_PURCHASED_STOCK';



export type Strategy = 'value' | 'momentum';

export interface PurchasedStock {
  symbol: string;
  quantity: number;
  total: number;
  price: number;
  orderType: 'Market' | 'Limit';
  tradeId: string;
}

export interface AddPurchasedStockAction {
  type: typeof ADD_PURCHASED_STOCK;
  payload: { strategy: Strategy; stock: PurchasedStock };
}

export interface SetPurchasedStocksAction {
  type: typeof SET_PURCHASED_STOCKS;
  payload: { strategy: Strategy; stocks: PurchasedStock[] };
}

export interface ClearPurchasedStocksAction {
  type: typeof CLEAR_PURCHASED_STOCKS;
  payload: { strategy: Strategy };
}

export interface RemovePurchasedStockAction {
  type: typeof REMOVE_PURCHASED_STOCK;
  payload: { strategy: Strategy; symbol: string };
}

export type PurchasedStocksAction =
  | AddPurchasedStockAction
  | SetPurchasedStocksAction
  | ClearPurchasedStocksAction
  | RemovePurchasedStockAction;

export interface PurchasedStocksState {
  value: PurchasedStock[];
  momentum: PurchasedStock[];
}